export enum SideName {
  BackSide = 'BackSide',
  DoubleSide = 'DoubleSide',
  FrontSide = 'FrontSide'
}
